// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"60c80c0d","758":"05064986"}[chunkId] + ".chunk.css";
};